import React, { useState } from 'react';
import { Routes, Route, useNavigate } from 'react-router-dom';
import Dashboard from './Dashboard';
import UploadFormEnhanced from './UploadFormEnhanced';
import BrandingSettings from './BrandingSettings';
import ProductList from './ProductList';
import ProductDetails from './ProductDetails';
import NotFound from './NotFound';

// Temporary inline types to resolve import issues
interface ProductMetadata {
  name: string;
  description: string;
  price: number;
  currency: string;
  category: string;
  materials: string[];
  dimensions: {
    height: number;
    width: number;
    depth: number;
    weight: number;
  };
  tags: string[];
}

interface MultiLanguageMetadata {
  de: ProductMetadata;
  en: ProductMetadata;
  fr: ProductMetadata;
  es: ProductMetadata;
}

interface RefinedProductData {
  refinedMetadata: MultiLanguageMetadata;
  sharedInformation: Record<string, unknown>;
  originalData: Record<string, unknown>;
  correlationId: string;
  agentSummary: string;
  shopify_product_id?: string;
  images?: string[];
}

const AppRoutes: React.FC = () => {
  const navigate = useNavigate();
  const [refinedData, setRefinedData] = useState<RefinedProductData | null>(null);

  const handleRefineProduct = (productData: RefinedProductData) => {
    setRefinedData(productData);
    navigate('/upload');
  };

  const clearRefinedData = () => {
    setRefinedData(null);
  };

  return (
    <Routes>
      <Route path="/" element={<Dashboard />} />      <Route 
        path="/upload" 
        element={
          <UploadFormEnhanced 
            refinedData={refinedData} 
            onClearRefinedData={clearRefinedData}
          />
        } 
      />
      <Route 
        path="/products" 
        element={<ProductList onRefineProduct={handleRefineProduct} />} 
      />
      <Route 
        path="/products/:productId" 
        element={<ProductDetails onRefineProduct={handleRefineProduct} />} 
      />
      <Route path="/settings/branding" element={<BrandingSettings />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
};

export default AppRoutes;